module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921024151_T.84ba1ab0.jpg";